<template>
    <div>
        <template>
            <b-card header-tag="header" footer-tag="footer" class="mt-8">
            <template v-slot:header>
                <p class="mb-0 text-center" style="font-size: 21px">Detalle del pedido #{{datos.id}}</p>
            </template>
            <b-card-text>
                <div><b>Realizado Por:</b> {{datos.nombre_usuario}}</div>
                <div><b>Fecha:</b> {{datos.created_at}}</div>
                <div><b>Nombre Cliente:</b> {{datos.nombre_cliente}}</div>
                <div><b>documento:</b> {{datos.documento_cliente}}</div>
                <div><b>correo:</b> {{datos.correo_cliente}}</div>
                <div><b>Telefono:</b> {{datos.telefono_cliente}}</div>
                <div><b>Dirección:</b> {{datos.direccion_cliente}}</div>
                <div><b>Departamento:</b> {{datos.nombre_departamento_pedido}}</div>
                <div><b>Ciudad:</b> {{datos.nombre_ciudad_pedido}}</div>
                <div v-if="pedidoProveedorId !== null">
                    <b v-if="canOrdersProv">Pedido Proveedor <router-link :to="{name: 'InfoPedidoProveedor', params:{ id: pedidoProveedorId}}">#{{pedidoProveedorId}}</router-link> </b>
                </div>
            </b-card-text>
            <b-card-text bg-variant="secondary">
                <p class="mb-0 text-center" style="font-size: 21px">Items Del pedido</p>
            </b-card-text>
            <b-card-text>
                <itemsComponent :productos="productos" :datos="datos"/>
            </b-card-text>
            <template v-slot:footer>
                <b-button id="volver" variant="danger" 
                    class="text-white mr-2" 
                    :to="{name: 'ListadoPedidos'}">
                    Volver Listado
                </b-button>
                <template v-if="canOrdersProv && pedidoProveDone && isItemsPropiosOnly === false">
                    <b-button variant="success" 
                        class="text-white mr-2" 
                        v-if="pedidoProveDone && isItemsPropiosOnly === false" 
                        @click.prevent="sendItemsData(productos)">
                        Solicitar Proveedor
                    </b-button>
                </template>
                <b-button variant="info" 
                    class="text-white mr-2" 
                    @click.prevent="printWindow()">
                    Imprimir
                </b-button>
                <a variant="info" 
                    class="text-white btn btn-info" 
                    :href="urlWebBackend+'download-pedido-cliente-excel/'+datos.id" target="_blank">
                    Exportar csv
                </a>
            </template>
        </b-card>
        </template>
        <!-- modal to create order proveedor -->
        <RequestOrderProveedor 
            :datos="datos"
            :itemsProveedor="itemsProveedor" 
            :liquidacionProveedor="liquidacionProveedor" 
            :modalPedidoProveedor="modalPedidoProveedor"
            :itemsNoAvailable="itemsNoAvailable"
            :comentario="comentario"
            :disableProcess="disableProcess"
            :servicioLogistico="servicioLogistico"
            :notLogisticServiceMessage='notLogisticServiceMessage'
            @close-modal="modalPedidoProveedor = false"
            @open-modal-order-comment="modalComment = true"
            @compare-available-amount="compareAvailableAmount($event, itemsProveedor)"
            @remove-item-to-proveedor="removeItemToProveedor($event, itemsProveedor)"
            @store-pedido-proveedor="confirmSendPedido($event, datos)"
            @servicio-logistico-change="servicioLogisticoChange($event, itemsProveedor)"
        />

        <!-- modal to add comment to order -->
        <CommentOrderModal 
            :modalComment="modalComment" 
            @close-modal="modalComment = false"
            @add-comment-to-order="addCommentToOrder($event)"
        />

        <LogisticServicePriceModal
            :itemsProveedor="itemsProveedor"
            :pedidoData="pedidoData"
            :costoFlete="costoFlete"
            :logisticServiceModal="logisticServiceModal"
            @close-modal="logisticServiceModal = false"
            @confirm-pedido="storePedidoProveedor($event, pedidoData)"
        />

    </div>
</template>
<script>
import itemsComponent from '../components/ItemsComponent.vue'
import { mapState, mapMutations } from 'vuex'
import RequestOrderProveedor from '../components/RequestOrderProveedor.vue'
import CommentOrderModal from '../components/CommentOrderModal.vue'
import LogisticServicePriceModal from '../components/LogisticServicePriceModal.vue'

export default {
    computed: {
        ...mapState('configuration', ['urlWebBackend']),
    },
    data(){
        return{
            errorMessage: "",
            pedidoProveedorId: null,
            datos: {},
            productos: [],
            itemsProveedor: [],
            liquidacionProveedor: {},
            modalPedidoProveedor: false,
            pedidoProveDone: false,
            isItemsPropiosOnly: true,
            canOrdersProv: false,
            id: this.$route.params.id,
            disableProcess: false,
            modalComment: false,
            comentario: null,
            servicioLogistico: false,
            notLogisticServiceMessage: '',
            logisticServiceModal: false,
            costoFlete: 0,
            pedidoData: {},
            itemsNoAvailable: []
        }
    },
    components: {
        itemsComponent,
        RequestOrderProveedor,
        CommentOrderModal,
        LogisticServicePriceModal
    },
    created(){
        this.getPedidoinfo();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPedidoinfo(){
            this.setLoading(true)
            this.userPermissions = localStorage.getItem('user_permissions');
            if(this.userPermissions.includes('can_orders_prov')){
                this.canOrdersProv = true;
            }
            await this.$conectar.post('pedidos/get-pedido-info', {id: this.id})
            .then(response =>{
                this.datos = response.data.pedidoLocal;
                this.productos = response.data.pedidoLocal.items;
                this.pedidoProveedorId = response.data.pedidoLocal.pedido_proveedor_id;
                if(response.data.pedidoLocal.pedido_proveedor_id === null){
                    this.pedidoProveDone = true;
                }
                this.isItemsPropiosOnly = response.data.isItemsPropiosOnly;
                
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
            
        },
        addCommentToOrder(comment){
            if(comment){
                this.comentario = comment;
                if (!comment.replace(/\s/g, '').length) {
                    this.comentario = null;
                }
            }else{
                this.comentario = null;
            }
            this.modalComment = false
        },
        removeItemToProveedor(index, itemsProveedor) {
            this.itemsProveedor.splice(index, 1);
            
            if(itemsProveedor.length < 1){
                this.modalPedidoProveedor = false;
            }else{
                this.updateItemCantidad(itemsProveedor);
            }
        },
        compareAvailableAmount(item, itemsProveedor){
            let cantidad = Number(item.cantidad);
            let existencia = Number(item.existencia);
            if(cantidad <= existencia){
                this.updateItemCantidad(itemsProveedor);
            }else{
                this.disableProcess = true;
            }
        }
        ,
        async sendItemsData(productos){
            this.disableProcess = false;
            this.setLoading(true)
            let cantidadReferencia = productos;
            let array = [];
             for (var key in cantidadReferencia) {
                if(cantidadReferencia[key].item_propio === 0){
                    array.push({
                        referencia: cantidadReferencia[key].referencia,
                        cantidad: cantidadReferencia[key].cantidad,
                    })
                }
            }
            await this.$conectar.post('pedidos/proveedor/get-pedido-info-and-price', {codigos: array, servicioLogistico: this.servicioLogistico, pedidoId: this.datos.id})
            .then(response =>{
                if(response.data.noAvailable){
                    this.disableProcess = true;
                }
                 if(response.data.notLogisticService){
                    this.notLogisticServiceMessage = response.data.notLogisticServiceMessage
                    this.disableProcess = true;
                }
                this.itemsNoAvailable = response.data.itemsNoAvailable;
                this.itemsProveedor = response.data.cartItems;
                this.liquidacionProveedor = response.data.cart;
                this.modalPedidoProveedor = true;
                this.costoFlete = response.data.costoFlete;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
            
        },
        async updateItemCantidad(itemsProveedor){
            this.disableProcess = false;
            this.setLoading(true)
            let cantidadReferencia = itemsProveedor;
            let array = [];
             for (var key in cantidadReferencia) {
                array.push({
                    referencia: cantidadReferencia[key].referencia,
                    cantidad: cantidadReferencia[key].cantidad,
                })
            }
            await this.$conectar.post('pedidos/proveedor/get-pedido-info-and-price', {codigos: array, servicioLogistico: this.servicioLogistico, pedidoId: this.datos.id})
            .then(response =>{
                this.itemsProveedor = response.data.cartItems;
                this.liquidacionProveedor = response.data.cart;
                this.modalPedidoProveedor = true;
                this.costoFlete = response.data.costoFlete;
                if(response.data.noAvailable){
                    this.disableProcess = true;
                }
                if(response.data.notLogisticService){
                    this.notLogisticServiceMessage = response.data.notLogisticServiceMessage
                    this.disableProcess = true;
                }
            })
            .catch(e => {
                console.log(e);
                this.modalPedidoProveedor = false;
            })
            this.setLoading(false)
            
        },
        async storePedidoProveedor(itemsProveedor, datos){
            this.setLoading(true)
            this.logisticServiceModal = false;
            let cantidadReferencia = itemsProveedor;
            let array = [];
             for (var key in cantidadReferencia) {
                array.push({
                    referencia: cantidadReferencia[key].referencia,
                    cantidad: cantidadReferencia[key].cantidad,
                })
            }
            let codigos = array;
            let sucursalId = datos.sucursal_id;
            let pedidoId = datos.id;
            let refSucursal = datos.referencia_sucursal;
            let comentario = this.comentario;
            let servicioLogistico = this.servicioLogistico;
            let pedidoData = { codigos, sucursalId, refSucursal, pedidoId, comentario, servicioLogistico}
            await this.$conectar.post('pedidos/proveedor/store-pedido', pedidoData)
            .then(response =>{
                if(response.data.error == true){
                    this.errorMessage = response.data.mensaje;
                    this.$root.$bvToast.toast(response.data.mensaje, {
                        title: "Respuesta del servidor",
                        variant: "danger",
                        solid: true
                    })
                }else{
                    this.$root.$bvToast.toast('EL pedido fue realizado correctamente', {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.pedidoProveDone = false;
                    let id = response.data.pedidoProveedor.id;
                    this.$router.push({ name: 'InfoPedidoProveedor', params:{ id: id} });
                }
            })
            .catch(e => {
                console.log(e);
                this.$root.$bvToast.toast('hubo un error en el servidor, contacte al administrador', {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.modalPedidoProveedor = false;
            this.setLoading(false)
            
        },
        servicioLogisticoChange(servicioLogistico, itemsProveedor){
            this.servicioLogistico = servicioLogistico;
            this.updateItemCantidad(itemsProveedor)
        },
        confirmSendPedido(itemsProveedor, pedidoData){
            if(this.servicioLogistico){
                this.logisticServiceModal = true;
                this.pedidoData = pedidoData;
            }else{
                this.storePedidoProveedor(itemsProveedor, pedidoData)
            }
        },
        printWindow() {
            window.print();
        }
    }
}
</script>
<style scoped>
.widthPersonalized{
    max-width: 400px;
}
.precio{
    min-width: 600px;
}
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}

.singleLines {
  white-space: nowrap !important;
  overflow: hidden !important;
}
@media print {
  button {
    display: none;
  }
  #volver{
    display: none;
  }
}


</style>